var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFacebookColor = function SvgFacebookColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.82 24H1.324C.594 24 0 23.406 0 22.676V1.324C0 .594.594 0 1.324 0h21.352C23.406 0 24 .594 24 1.324v21.352c0 .73-.594 1.324-1.324 1.324h-6.117v-9.293h3.12l.466-3.625h-3.586V8.77c0-1.047.293-1.762 1.796-1.762h1.918V3.766a26.231 26.231 0 00-2.796-.141c-2.766 0-4.657 1.688-4.657 4.79v2.667H9.691v3.625h3.13zm0 0",
    fillRule: "evenodd",
    fill: "#4460a0"
  })));
};
export default SvgFacebookColor;